import axios from "axios";
import { BASE_URL } from "../actions/types";

const api = axios.create({
  baseURL: BASE_URL,
});

export default api;
